export enum SpecificationEnum {
  PURPOSE_BUILT = 'PurposeBuilt',
  CONVERSION = 'Conversion',
  HOUSE_IN_MULTIPLE_OCCUPATION = 'HouseInMultipleOccupation',
}
